export { default as Delete } from './Delete';
export { default as Palette } from './Palette';
export { default as Brush } from './Brush';
export { default as Undo } from './Undo';
export { default as Eraser } from './Eraser';
